import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';
import { badgeVariants } from './badge-variants';

export type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>;
export type BadgeSize = NonNullable<VariantProps<typeof badgeVariants>['size']>;

const Badge = ({
  className,
  variant = 'default',
  size = 'default',
  ...props
}: ComponentProps<'span'> & VariantProps<typeof badgeVariants>) => {
  return <span className={cn(badgeVariants({ variant, size }), className)} {...props} />;
};

export { Badge };
